import React, { useEffect } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { useStateRouterContext } from '@uhg-abyss/web/ui/StateRouter';
import { PracticeManagement } from '../../TopNav';
import { defaultEmptyFunction } from '../config';

const StyledHeading = styled(Heading, {
  '&.abyss-heading-root': {
    marginTop: '16px',
    padding: '8px 16px',
    fontWeight: 'bold',
    fontSize: '18px',
    color: '$gray8 !important',
  },
});

export const PracticeManagementContent = () => {
  const { methods } = useStateRouterContext() || {
    methods: { goBack: defaultEmptyFunction },
  };

  useEffect(() => {
    return () => {
      methods.goBack();
    };
  }, []);

  return (
    <React.Fragment>
      <StyledHeading offset={4}>Practice Management</StyledHeading>
      <PracticeManagement />
    </React.Fragment>
  );
};
